import * as React from 'react';
import { Select, Spin } from "antd";
import { useState } from "react";
import { LabeledValue } from "antd/es/select";
import { MultipleSelectWithTableValue } from "./MultipleChoicesWithTable";

const { Option } = Select;

export interface MultipleChoicesSelectProps {
  onValueSelected?: Function;
  onSearch?: Function;
  initialDataSource?: LabeledValue[];
  placeholder?: string;
}

export default function MultipleChoicesSelect(props: MultipleChoicesSelectProps) {
  const { onValueSelected, onSearch, placeholder, initialDataSource } = props;
  const [originalDataSource] = useState<MultipleSelectWithTableValue[]|undefined>(initialDataSource);
  const [dataSource, setDataSource] = useState<MultipleSelectWithTableValue[]|undefined>(originalDataSource);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const setValue = useState<LabeledValue|undefined>(undefined)[1];

  const onChange = (selectedValue: LabeledValue) => {
    setValue(selectedValue);
    const fullValue = dataSource && dataSource.filter((item) => {
      return String(item.id) === String(selectedValue.value);
    })
    onValueSelected && onValueSelected(fullValue && fullValue[0]);
  };

  const defaultSearch = (queryString: string) => {
    if (dataSource) {
      setDataSource(dataSource.filter((row: MultipleSelectWithTableValue) => {
        return String(row.label).match(RegExp(queryString, 'i'));
      }));
    }
  };

  const onSelectSearch = async (value: string) => {
    setIsLoading(true);
    if (value === '' && originalDataSource) {
      setDataSource(originalDataSource);
    }

    const values = onSearch ? await onSearch(value) : defaultSearch(value);
    if (values) {
      setDataSource(values);
    }
    setIsLoading(false);
  };

  return <Select
    showSearch
    labelInValue
    autoClearSearchValue={false}
    defaultActiveFirstOption={false}
    filterOption={false}
    placeholder={placeholder ? placeholder : "Please select"}
    style={{ width: '100%' }}
    onChange={onChange}
    onSearch={onSelectSearch}
    notFoundContent={isLoading ? <div><Spin size="small" /> Loading...</div> : null}
    loading={isLoading}
  >
    {dataSource && dataSource.map((row: MultipleSelectWithTableValue) => {
      return <Option key={String(row.label) + row.id} value={row.id}>{row.label}</Option>
    })}
  </Select>
}